import { EProjectPlatform, IBaseConfigs } from './types';

const webConfigs: IBaseConfigs = {
  baseURL: '',
  chartDomain: `/chart`,
  platform: EProjectPlatform.WEB,
  routePathPrefix: `/${APP_PATH}`,
  socketPathPrefix: `//${location.host}`
};

export default webConfigs;
